import type { DisplayLoyaltyTier } from "@/api/orval/model";
import { useTranslation } from "@/core/i18n";

type TierBenefitsProps = {
  readonly tier: DisplayLoyaltyTier;
  /** "onDark" on the celebration's backdrop; "onLight" on a card. */
  readonly tone: "onLight" | "onDark";
};

/**
 * What holding a tier gives the client: its members-only text (the API sends it only on the tier
 * they hold) and its public description. Tier rewards join here.
 */
export const TierBenefits = ({ tier, tone }: TierBenefitsProps) => {
  const { t } = useTranslation();
  const { membersOnlyDescription, description } = tier;
  const primaryText = tone === "onDark" ? "text-white" : "text-primary";
  const secondaryText = tone === "onDark" ? "text-white/70" : "text-secondary";

  if (!membersOnlyDescription && !description) {
    return <p className={`text-body2 ${secondaryText}`}>{t("loyalty.benefitsComingSoon")}</p>;
  }

  return (
    <div className="flex flex-col gap-2">
      {membersOnlyDescription && (
        <p className={`whitespace-pre-line text-body1 ${primaryText}`}>{membersOnlyDescription}</p>
      )}
      {description && <p className={`text-body2 ${secondaryText}`}>{description}</p>}
    </div>
  );
};
